import { useLocalObservable } from 'mobx-react-lite';

import { ICommonPopupsProps } from '@gem/popups';

import Tasks from 'APP/Tasks';
import { TChatBackground } from 'APP/store/Appearance/Appearance.types';
import Entities from 'STORE';

interface IChatBackgroundPopupPresenter {
  selectedBackground: TChatBackground;
  hasChanges: boolean;
  hasBackButton: boolean;
  entityId: string | null;
  onBackgroundChange(chatBackground: TChatBackground): void;
  onApply(): void;
  onClose(): void;
  onBack(): void;
}

function getInitialBackground(entityId: string | null): TChatBackground {
  return Entities.appearance.getChatBackgroundForEntity(entityId);
}

function getEntityId(): string | null {
  return Entities.GroupsStore.activeGroupId ?? null;
}

export function useChatBackgroundPopupPresenter({
  popupInstance,
  onClose,
  onBack,
}: ICommonPopupsProps): IChatBackgroundPopupPresenter {
  const presenter = useLocalObservable<IChatBackgroundPopupPresenter>(() => {
    const initialBackground = getInitialBackground(getEntityId());

    return {
      selectedBackground: initialBackground,

      get entityId(): string | null {
        return getEntityId();
      },

      get hasChanges(): boolean {
        return presenter.selectedBackground !== initialBackground;
      },

      get hasBackButton(): boolean {
        return !!onBack;
      },

      onBackgroundChange(chatBackground: TChatBackground): void {
        presenter.selectedBackground = chatBackground;
      },

      onApply(): void {
        if (!presenter.hasChanges || !presenter.entityId) {
          return;
        }

        Tasks.appearance.setChatBackgroundForEntity(
          presenter.entityId,
          presenter.selectedBackground
        );
        presenter.onClose();
      },

      onClose(): void {
        popupInstance.close();
        onClose?.();
      },

      onBack(): void {
        popupInstance.close();
        onBack?.();
      },
    };
  });

  return presenter;
}
